import axios from 'axios'

export default axios.create({
    baseURL: window?.React?.base_url || `https://new.giftcardgrannystage.com/`, // window.React.base_url for when calling custom hooks in live env, stage url for when running React unit tests using jsdom env
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
})
